import "./src/styles/global.css";
import {
  trackPageview,
  installEngagementTracking,
  resetScrollDepthForRoute,
  configureResearchPrivacy,
} from "./src/helpers/analytics";

export const onClientEntry = () => {
  configureResearchPrivacy(window.location.pathname);
  installEngagementTracking();
};

export const onRouteUpdate = () => {
  configureResearchPrivacy(window.location.pathname);
  trackPageview();
  resetScrollDepthForRoute();
};

export const onPreRouteUpdate = ({ location }) =>
  configureResearchPrivacy(location.pathname);
